import { getEndPoint } from './getEndPoint'
export const getTags = () =>
  getEndPoint('wp/v2/tags?orderby=count&order=desc&per_page=20')
